import Plyr from "plyr";

let VideoPlayer = {
    init: () => {
        delete window.player;

        if ($('.video-player').length) window.player = new Plyr('.video-player');
    }
};

export default VideoPlayer;

